'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _underscore = require('../utils/underscore');

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _UIAbstractNumberInput = require('./abstract/UIAbstractNumberInput');

var _UIAbstractNumberInput2 = _interopRequireDefault(_UIAbstractNumberInput);

var _UITextInput = require('./UITextInput');

var _UITextInput2 = _interopRequireDefault(_UITextInput);

var _Functions = require('../core/Functions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var UINumberInput = _react2.default.createClass({
  displayName: 'UINumberInput',

  propTypes: _extends({}, (0, _underscore.omit)(_UITextInput2.default.propTypes, ['type']), (0, _underscore.omit)(_UIAbstractNumberInput2.default.propTypes, ['children']), {
    className: _react.PropTypes.string
  }),

  getDefaultProps: function getDefaultProps() {
    return _extends({}, _UITextInput2.default.defaultProps, _UIAbstractNumberInput2.default.defaultProps);
  },
  focus: function focus() {
    if (this._inputRef) {
      this._inputRef.focus();
    }
  },
  select: function select() {
    if (this._inputRef) {
      this._inputRef.select();
    }
  },
  inputRefCallback: function inputRefCallback(ref) {
    this._inputRef = ref;
    (0, _Functions.callIfPossible)(ref);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        className = _props.className,
        type = _props.type,
        props = _objectWithoutProperties(_props, ['className', 'type']);

    if (type !== _UITextInput2.default.defaultProps.type) {
      _devLogger2.default.warn({
        message: 'UINumberInput: The `type` prop is a no-op (#4178)',
        key: 'UINumberInput: type'
      });
    }
    return _react2.default.createElement(
      _UIAbstractNumberInput2.default,
      props,
      function (numberProps) {
        return _react2.default.createElement(_UITextInput2.default, _extends({}, numberProps, {
          className: (0, _reactUtils.classNames)('uiNumberInput', className),
          ref: _this.inputRefCallback,
          type: 'text'
        }));
      }
    );
  }
});

exports.default = (0, _Controllable2.default)(UINumberInput);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/input/UINumberInput.js
// module id = 365
// module chunks = 0